import { render, staticRenderFns } from "./MessageNavi.vue?vue&type=template&id=10faa0c8"
import script from "./MessageNavi.vue?vue&type=script&lang=js"
export * from "./MessageNavi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports